import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardLayout = props => {
  const {
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-layout-dashboard");
  return /*#__PURE__*/_jsx("div", {
    className: classNames(baseClassName, className),
    style: style,
    children: children
  });
};
export default DashboardLayout;